export function getVisibleWindow(data = [], requestedPage = 0, windowSize = 12) {
  const rows = Array.isArray(data) ? data : [];
  const safeSize = Math.max(1, windowSize);
  const pageCount = rows.length === 0 ? 0 : Math.ceil(rows.length / safeSize);
  const page = pageCount === 0 ? 0 : Math.min(Math.max(0, requestedPage), pageCount - 1);
  const start = page * safeSize;

  return {
    rows: rows.slice(start, start + safeSize),
    page,
    pageCount,
    canGoPrevious: page > 0,
    canGoNext: pageCount > 0 && page < pageCount - 1,
  };
}
